export default "__VITE_ASSET__gLTJkq$S__"